import React, { useEffect, useState, useLayoutEffect } from "react";
import { Layout, Menu, Drawer, Popover, Badge, Tabs_, Tooltip } from "components/common";
import styled from "styled-components";
import BaseLayout from "../base/BaseLayout";
import WebViewLogo from "assets/images/img-logo.png";
import MblViewLogo from "assets/images/img-mbl-logo.png";
import calender from "assets/images/calender.png";
import notificaiton from "assets/images/notificaiton.png";
import customer from "assets/images/customer.png";
import payments from "assets/images/payments.png";
import users from "assets/images/users.png";
import reports from "assets/images/reports.png";
import settings from "assets/images/settings.png";
import notify from "assets/images/notify.png";
import logout from "assets/images/logout.png";
import { useHistory, useLocation } from "react-router";
import { checkAthenticatedUser, removeStorage } from "utils/auth";
import { getUserPermissions } from "utils/text";
import { getUser } from "utils/auth";
import { callGetApiWithAuth } from "utils/api";
import { useSelector } from "react-redux";
import NotificationPopup from "../../views/NotificationPopup/NotificationPopup";
import { HiBars3CenterLeft } from "react-icons/hi2"
import { FaBars } from "react-icons/fa"
import { MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const { Header, Sider, Content } = Layout;

export default function AuthedLayout({ children }) {
    const location = useLocation();
    const user = getUser();
    const history = useHistory();
    const [collapsed, setCollapsed] = useState(false);
    const [sidebar, setSidebar] = useState(false);
    const [visible, setVisible] = useState(false);
    const [openKeys, setOpenKeys] = useState([]);
    const [notiData, setNotiData] = useState([]);
    const [msgData, setMsgData] = useState([]);
    const [isTask, isSetTask] = useState([]);

    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 900) {
                setIsSmallScreen(true);
            } else {
                if (location?.pathname.includes("notification-panel")) {
                    history.push(`/leads?offset=0&limit=10`);
                }
                return setIsSmallScreen(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    let AllCount = msgData?.length + notiData?.length + isTask?.length;

    let notii = useSelector((state) => state.common.notification);
    let mesg = useSelector((state) => state.common.messages);
    let tasks = useSelector((state) => state.common.task);

    const checkAuth = () => {
        callGetApiWithAuth("/auth/me", onSuccessCheckAuth, onFailedCheckAuth);
    };
    const gettask = () => {
        callGetApiWithAuth("/notification/all/tasks", onSuccessGetTask, onFailedgetTask);
    };

    const onSuccessGetTask = (data) => {
        isSetTask(data);
    };
    const onFailedgetTask = (err) => {
        console.log(err);
    };

    const onSuccessCheckAuth = (data) => {
        // if (data?.isTokenExprired) {
        //     removeStorage();
        //     history.push("/login");
        // }
    };

    const onFailedCheckAuth = (err) => { };

    const notificationData = () => {
        callGetApiWithAuth("/notification/all/notifications", onSuccessNotiGetApi, onFailedNotiGetApi);
    };
    // const messageTaskGetApi = () => {
    //   callGetApiWithAuth("Task", onSuccessGetTaskApi, onFailedGetTaskApi);
    // };
    const messageNotiGetApi = () => {
        callGetApiWithAuth("/notification/all/messages", onSuccessGetMessageApi, onFailedGetMessageApi);
    };
    const onSuccessGetTaskApi = (data) => {
        isSetTask(data);
    };
    const onFailedGetTaskApi = (err) => {
        console.log(err);
    };
    const onSuccessGetMessageApi = (data) => {
        setMsgData(data);
    };

    const onFailedGetMessageApi = (err) => {
        console.log(err);
    };

    const onSuccessNotiGetApi = (data) => {
        setNotiData(data);
    };

    const onFailedNotiGetApi = (err) => {
        console.log(err);
    };

    useEffect(() => {
        notificationData();
        messageNotiGetApi();
        // messageTaskGetApi();
        gettask();
    }, [notii, mesg, tasks]);

    const onClose = () => {
        setVisible(false);
    };

    const handleMenuClick = (key) => {
        onClose(); // Close the drawer
        history.push(`/${key}`);
    };

    useEffect(() => {
        // checkAuth();
        if (!checkAthenticatedUser()) {
            history.push("/login");
        }
    }, []);

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 950) {
                setSidebar(true);
            } else {
                return setSidebar(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    const notifications = [
        {
            notification: "Heelloo There",
            name: "Asif",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
        {
            notification: "I am SkyWalker",
            name: "Lark",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
    ];
    const messages = [
        {
            message: "Heelloo There",
            name: "Asif",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
        {
            message: "I am SkyWalker",
            name: "Lark",
            avatar: "https://source.unsplash.com/random/800x800/?img=1",
            time: new Date().toLocaleTimeString(),
        },
    ];

    // <Badge count={5}>
    //   <Avatar shape="square" size="large" />
    // </Badge>;
    const content = (
        <Tabs_
            notifications={notifications}
            messages={messages}
            notiData={notiData}
            msgData={msgData}
            isTask={isTask}
            gettask={gettask}
            notificationData={notificationData}
            messageNotiGetApi={messageNotiGetApi}
        // messageTaskGetApi={messageTaskGetApi}
        />
    );
    const notification = (
        <NotificationPopup />
    );
    let task = isTask?.length > 0 ? "error" : "success";

    return (
        <BaseLayout>
            <Wrapper>
                <Layout>

                    <Sider width={240} trigger={null} collapsible collapsed={collapsed}>
                        <div className="logo">{collapsed ? <img src={MblViewLogo} alt="" /> : <img src={WebViewLogo} alt="" />}</div>
                        <div className="sub-mewnu-container">
                            <Menu
                                theme="dark"
                                mode="inline"
                                defaultSelectedKeys={[history?.location?.pathname?.slice(1)]}
                                onClick={(value) => {
                                    history.push(`/${value?.key}`);
                                }}
                            >
                                {getUserPermissions("leads-view-action") && (
                                    <Menu.Item key="leads?offset=0&limit=10">
                                        <img src={customer} alt="customer" style={{ marginRight: "28px" }} />
                                        <span>Customers</span>
                                    </Menu.Item>
                                )}
                                {getUserPermissions("expenses-view-action") || getUserPermissions("payroll-view-action") || getUserPermissions("pay-history-view-action") ? (
                                    <Menu.SubMenu title="Payments" icon={<img src={payments} alt="payments" style={{ marginRight: "18px" }} />}>
                                        {getUserPermissions("expenses-view-action") && (
                                            <Menu.Item key="payments-expenses">
                                                <span>Expenses</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("payroll-view-action") && (
                                            <Menu.Item key="payrole">
                                                <span>Payroll</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("pay-history-view-action") && (
                                            <Menu.Item key="payhistory">
                                                <span>Pay History</span>
                                            </Menu.Item>
                                        )}
                                    </Menu.SubMenu>
                                ) : (<></>)}
                                {getUserPermissions("users-view-action") && (
                                    <Menu.Item key="users?offset=0&limit=10&active=true">
                                        <img src={users} alt="users" style={{ marginRight: "30px" }} />
                                        <span>Users</span>
                                    </Menu.Item>
                                )}
                                {getUserPermissions("setter-leaderboard-action") || getUserPermissions("closer-leaderboard-action") ? (
                                    <Menu.SubMenu title="Reports" icon={<img src={reports} alt="reports" style={{ marginRight: "15px" }} />}>
                                        {getUserPermissions("setter-leaderboard-action") && (
                                            <Menu.Item key="setter-leader-board">
                                                <span>Setter Leaderboard</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("closer-leaderboard-action") && (
                                            <Menu.Item key="closer-leader-board">
                                                <span>Closer Leaderboard</span>
                                            </Menu.Item>
                                        )}
                                    </Menu.SubMenu>
                                ) : (<></>)}
                                <Menu.SubMenu title="Settings" icon={<img src={settings} alt="settings" style={{ marginRight: "17px" }} />} className="setting-submenu">
                                    {getUserPermissions("statuses-view-action") && (
                                        <Menu.Item key="status">
                                            <span>Statuses</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("lead-rotation-view-action") && (
                                        <Menu.Item key="priority">
                                            <span>Lead Rotation</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("roles-view-action") && (
                                        <Menu.Item key="roles">
                                            <span>Roles</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("expense-categories-view-action") && (
                                        <Menu.Item key="expense-categories">
                                            <span>Expense Categories</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("developers-view-action") && (
                                        <Menu.Item key="developers">
                                            <span>Developers</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("my-profile-view-action") && (
                                        <Menu.Item key="myprofile">
                                            <span>My Profile</span>
                                        </Menu.Item>
                                    )}
                                </Menu.SubMenu>
                                {getUserPermissions("send-messages") && (
                                    <Menu.Item key="notify-page">
                                        <img src={notify} alt="notify" style={{ marginRight: "31px" }} />
                                        <span> Notify Page </span>
                                    </Menu.Item>
                                )}
                            </Menu>
                            <Menu
                                theme="dark"
                                mode="inline"
                                onClick={() => {
                                    removeStorage();
                                    history.push(`/login`);
                                }}
                            >
                                <Menu.Item key="logout">
                                    <img src={logout} alt="logout" style={{ marginRight: "31px" }} />
                                    <span>Logout</span>
                                </Menu.Item>
                            </Menu>
                        </div>
                    </Sider>
                    <Layout className={collapsed ? "collapsed-site-layout" : "site-layout"}>
                        <Header
                            className="site-layout-background"
                            style={{
                                padding: 0,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                {sidebar ? (
                                    <FaBars size={24} style={{ marginLeft: 15 }} onClick={() => setVisible(true)} cursor="pointer" />
                                ) : (
                                    <HiBars3CenterLeft size={40} style={{ transform: `scaleX(${collapsed ? 1 : -1})` }} cursor="pointer" onClick={() => setCollapsed(!collapsed)} />
                                )}
                                {/* {sidebar
                                    ? React.createElement(MenuOutlined, {
                                        className: "trigger",
                                        onClick: () => setVisible(true),
                                    })
                                    : React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                        className: "trigger",
                                        onClick: () => setCollapsed(!collapsed),
                                    })} */}
                                {/* <Col span={2}> */}
                                {(getUserPermissions("view-notifications") || getUserPermissions("view-messages")) && (
                                    <div
                                    // style={{ display: "flex", justifyContent: "space-between" }}
                                    >
                                        {getUserPermissions("events-calendar-view-action") && (
                                            <Tooltip placement="rightBottom" color="#1890ff" title="Calendar">
                                                <img
                                                    src={calender}
                                                    alt="calender"
                                                    onClick={() => {
                                                        history.push("/events-calendar");
                                                    }}
                                                    style={{
                                                        fontSize: "30px",
                                                        cursor: "pointer",
                                                    }}
                                                ></img>
                                            </Tooltip>
                                        )}

                                        {
                                            isSmallScreen ? (
                                                <span onClick={() => {
                                                    history.push(`/notification-panel`);
                                                }}>
                                                    <Badge count={AllCount} status={task}>
                                                        <img
                                                            src={notificaiton}
                                                            alt="notification"
                                                            style={{
                                                                marginLeft: "25px",
                                                                fontSize: "30px",
                                                                marginRight: "25px",
                                                            }}
                                                            onClick={() => {
                                                                history.push(`/notification-panel`);
                                                            }}
                                                        />
                                                    </Badge>
                                                </span>
                                            ) : (
                                                <Popover
                                                    placement="bottomRight"
                                                    content={notification}
                                                    trigger="click">

                                                    <Badge count={AllCount} status={task}>
                                                        <img
                                                            src={notificaiton}
                                                            alt="notification"
                                                            style={{
                                                                marginLeft: "25px",
                                                                fontSize: "30px",
                                                                marginRight: "25px",
                                                            }}
                                                        />
                                                    </Badge>
                                                    {/* </img> */}
                                                </Popover>
                                            )
                                        }
                                    </div>
                                )}
                                {/* </Col> */}
                            </div>
                        </Header>
                        <Drawer title={<div className="logo">{<img src={WebViewLogo} alt="" />}</div>} placement="left" onClose={onClose} visible={visible}>
                            <div className="sub-menu-drawer-container">
                                <Menu
                                    className="drawer-menu"
                                    theme="dark"
                                    mode="inline"
                                    defaultSelectedKeys={[history?.location?.pathname?.slice(1)]}
                                    onClick={({ key }) => handleMenuClick(key)} // Modified event handler

                                >
                                    {getUserPermissions("leads-view-action") && (
                                        <Menu.Item key="leads?offset=0&limit=10">
                                            <img src={customer} alt="customer" style={{ marginRight: "10px" }} />
                                            <span>Customers</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("expenses-view-action") || getUserPermissions("payroll-view-action") || getUserPermissions("pay-history-view-action") ? (
                                        <Menu.SubMenu title="Payments" icon={<img src={payments} alt="payments" />}>
                                            {getUserPermissions("expenses-view-action") && (
                                                <Menu.Item key="payments-expenses">
                                                    <span>Expenses</span>
                                                </Menu.Item>
                                            )}
                                            {getUserPermissions("payroll-view-action") && (
                                                <Menu.Item key="payrole">
                                                    <span>Payroll</span>
                                                </Menu.Item>
                                            )}
                                            {getUserPermissions("pay-history-view-action") && (
                                                <Menu.Item key="payhistory">
                                                    <span>Pay History</span>
                                                </Menu.Item>
                                            )}
                                        </Menu.SubMenu>
                                    ) : (<></>)}
                                    {getUserPermissions("users-view-action") && (
                                        <Menu.Item key="users?offset=0&limit=10&active=true">
                                            <img src={users} alt="users" style={{ marginRight: "15px" }} />
                                            <span>Users</span>
                                        </Menu.Item>
                                    )}
                                    {getUserPermissions("setter-leaderboard-action") || getUserPermissions("closer-leaderboard-action") ? (
                                        <Menu.SubMenu title="Reports" icon={<img src={reports} alt="reports" />}>
                                            {getUserPermissions("setter-leaderboard-action") && (
                                                <Menu.Item key="setter-leader-board">
                                                    <span>Setter Leaderboard</span>
                                                </Menu.Item>
                                            )}
                                            {getUserPermissions("closer-leaderboard-action") && (
                                                <Menu.Item key="closer-leader-board">
                                                    <span>Closer Leaderboard</span>
                                                </Menu.Item>
                                            )}
                                        </Menu.SubMenu>
                                    ) : (<></>)}
                                    <Menu.SubMenu title="Settings" icon={<img src={settings} alt="settings" />}>
                                        {getUserPermissions("statuses-view-action") && (
                                            <Menu.Item key="status">
                                                <span>Statuses</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("lead-rotation-view-action") && (
                                            <Menu.Item key="priority">
                                                <span>Lead Rotation</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("roles-view-action") && (
                                            <Menu.Item key="roles">
                                                <span>Roles</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("expense-categories-view-action") && (
                                            <Menu.Item key="expense-categories">
                                                <span>Expense Categories</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("developers-view-action") && (
                                            <Menu.Item key="developers">
                                                <span>Developers</span>
                                            </Menu.Item>
                                        )}
                                        {getUserPermissions("my-profile-view-action") && (
                                            <Menu.Item key="myprofile">
                                                <span>My Profile</span>
                                            </Menu.Item>
                                        )}
                                    </Menu.SubMenu>
                                    {getUserPermissions("send-messages") && (
                                        <Menu.Item key="notify-page">
                                            <img src={notify} alt="notify" style={{ marginRight: "10px" }} />
                                            <span> Notify Page </span>
                                        </Menu.Item>
                                    )}
                                </Menu>
                                <Menu
                                    theme="dark"
                                    className="drawer-menu"
                                    mode="inline"
                                    onClick={() => {
                                        removeStorage();
                                        history.push(`/login`);
                                    }}
                                >
                                    <Menu.Item key="logout">
                                        <img src={logout} alt="logout" style={{ marginRight: "10px" }} />
                                        <span>Logout</span>
                                    </Menu.Item>
                                </Menu>
                            </div>
                        </Drawer>
                        <Content
                            className="site-layout-background"
                            style={
                                location?.pathname.includes("customer-details") ||
                                    (location?.pathname.includes("lead") && !location?.pathname.includes("leads") && isSmallScreen
                                        || location?.pathname.includes("user") && !location?.pathname.includes("users") && isSmallScreen)
                                    || (location?.pathname.includes("notification-panel") && isSmallScreen) || (location?.pathname.includes("priority"))
                                    ? null
                                    : { padding: "24px", margin: "10px 0px" }
                            }
                        >
                            {children}
                        </Content>
                    </Layout>
                </Layout>
            </Wrapper >
        </BaseLayout >
    );
}

const Wrapper = styled.div`
    height: 100%;
    .ant-layout-header {
        z-index: 1;
    }
    .sub-mewnu-container {
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 90px);
    }
    .sub-mewnu-container::-webkit-scrollbar-track {
        background-color: #131f28;
    }
    .sub-mewnu-container::-webkit-scrollbar {
        width: 7px;
        background-color: #f5f5f5;
    }
    .sub-mewnu-container::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #131f28;
    }
    @media (max-width: 950px) {
        .ant-layout-sider {
            display: none;
        }
    }

    .trigger {
        padding: 0 24px;
        font-size: 18px;
        line-height: 64px;
        cursor: pointer;
        transition: color 0.3s;
    }
    .trigger:hover {
        color: #1890ff;
    }
    .logo {
        height: 40px;
        margin: 20px 16px 30px;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .collapsed-site-layout {
        margin-left: 80px;
        position: fixed;
        width: calc(100% - 80px) !important;
        overflow: auto;

        .ant-layout-header {
            padding: 0px;
            position: fixed;
            width: calc(100% - 80px);
        }
        .ant-layout-content {
            margin-top: 64px !important;
        }

        @media (max-width: 950px) {
            margin-left: 0px;
            width: 100% !important;
            .ant-layout-content {
                min-height: auto !important;
            }
        }
    }
    .collapsed-site-layout .site-layout-background {
        // background: #e1eff6;
    }
    .site-layout {
        margin-left: 240px;
        position: fixed;
        width: calc(100% - 240px) !important;
        overflow: auto;
        .ant-layout-header {
            z-index: 3 !important;
            padding: 0px;
            position: fixed;
            width: calc(100% - 240px);
        }
        .ant-layout-content {
            margin-top: 64px !important;
        }
        @media (max-width: 950px) {
            margin-left: 0px;
            width: 100% !important;
            .ant-layout-content {
                min-height: auto !important;
            }
            .ant-layout-header {
                width: 100%;
            }
        }
    }

    .site-layout .site-layout-background {
        // background: #e1eff6;
    }
    .ant-menu.ant-menu-dark,
    .ant-menu-dark .ant-menu-sub,
    .ant-menu.ant-menu-dark .ant-menu-sub {
        background: #131f28;
    }
    .ant-layout-sider {
        background: #131f28;
        position: fixed;
        z-index: 10;
        height: 100%;
    }

    .ant-layout-header svg {
        color: white;
    }
    .ant-menu-title-content {
        display: flex;
        align-items: center;
        font-size: 17px;
        svg {
            font-size: 17px;
        }
    }
    .ant-layout-header {
        background: #131f28 !important;
    }
    .ant-badge-count {
        margin: 22px 22px 0px 0px !important;
        width: 18px !important;
        height: 18px;
        display: flex;
        justify-content: center;
        font-size: 8px;
        line-height: 17px !important;
        min-width: 0px !important;
    }
`;
